module.exports = __webpack_public_path__ + "static/img/108.d60910aa.png";